import React from 'react'
import { FeaturedLayout } from '../../layouts'
import SolicitudesPagoTab from './SolicitudesPagoTab'

const PagosSolicitudes = () => {
  return (
    <FeaturedLayout
      title="Solicitudes de pago"
      subtitle="Revisa los pagos enviados por padres desde el estado de cuenta publico"
    >
      <SolicitudesPagoTab />
    </FeaturedLayout>
  )
}

export default PagosSolicitudes
